import React from 'react';
import {Row, Col, Media} from 'react-bootstrap';
import HeaderLogo from '../Components/HeaderLogo';
import HeaderTitle from '../Components/HeaderTitle';
//import Navigation from '../Components/Navigation';
//import Footer from '../Components/Footer';
import {MORSContainer} from '../../theme/MorsTheme';

const ExpPwdLayout = ({component:Component, ...props}) => 
(    
    <MORSContainer>
        <Row>
            <Col as={Col} md={3} sm={12} xs={12}>       
                <Row noGutters>
                    <Media style={{paddingTop:'63px'}}>                
                        <HeaderLogo/>                
                    </Media>       
                </Row>                    
                <Row noGutters className="d-none d-sm-block">
                    <Col as={Col}>
                        
                    </Col>
                </Row>
            </Col>       
            <Col as={Col} md={9} sm={12} xs={12} className="d-none d-md-block">                                              
                <HeaderTitle hideBreadCrumb = {true}/>                                                
                <Component {...props}/>          
                                      
                {/*
                <Footer {...props}/>                 */}
            </Col>                      
        </Row>          
    </MORSContainer>         
  
);

export default ExpPwdLayout;